module.exports = __webpack_public_path__ + "img/boite-de-reception.53a48c24.png";